// nosemgrep: nodejs_scan.javascript-crypto-rule-node_insecure_random_generator
export class UUID {
  static v7 = (): string => {
    const crypto = window.crypto

    const timestamp = Date.now()
    const timestampHex = timestamp.toString(16).padStart(12, '0')

    const randomBytes = new Uint8Array(10)
    crypto.getRandomValues(randomBytes)

    let byteIndex = 0
    let nibbleIndex = 0

    const getNextRandomHex = (): number => {
      const byte = randomBytes[byteIndex]
      const value = nibbleIndex === 0 ? (byte >> 4) & 0x0f : byte & 0x0f

      nibbleIndex++
      if (nibbleIndex === 2) {
        nibbleIndex = 0
        byteIndex++
      }

      return value
    }

    const timestampPart1 = timestampHex.slice(0, 8)
    const timestampPart2 = timestampHex.slice(8, 12)
    const versionAndRandom =
      '7' + Array.from({ length: 3 }, () => getNextRandomHex().toString(16)).join('')

    const variantValue = getNextRandomHex()
    const variant = ((variantValue & 0x3) | 0x8).toString(16)
    const variantAndRandom =
      variant + Array.from({ length: 3 }, () => getNextRandomHex().toString(16)).join('')
    const finalRandom = Array.from({ length: 12 }, () => getNextRandomHex().toString(16)).join('')

    return `${timestampPart1}-${timestampPart2}-${versionAndRandom}-${variantAndRandom}-${finalRandom}`
  }
}
